<template>
    <OpSessionManager/>
    <LegacyApp v-if="isLegacyTheme($route.name)" />
    <template v-else>
        <router-view></router-view>
        <BsModal :modelValue="showInstallModal" persistent class="system-modal">
            <template #title>
                Instale o aplicativo!
            </template>
            <p>
                Acesse o app rapidamente através do ícone na tela inicial do seu dispositivo.
            </p>
            <template #actions>
                <BsButton color="primary" height="44"
                          :prepend-icon="useIcon('download light')" @click="acceptInstall" block>
                    Instalar agora!
                </BsButton>
                <BsButtonOutlined color="primary" height="44"
                                  :prepend-icon="useIcon('alarmClock light')" @click="declineInstall" block>
                    Lembre-me mais tarde
                </BsButtonOutlined>
            </template>
        </BsModal>
        <BsModal :modelValue="isUpdateAvailable" class="system-modal" persistent>
            <template #title>
                Atualize o App!
            </template>
            <p>
                Uma nova versão do App do Educador está disponível. Recarregue o App para aplicar as melhorias e ter uma experiência ainda melhor.
            </p>
            <template #actions>
                <BsButton color="primary" height="44"
                          :loading="updating"
                          :prepend-icon="loadImage('reload')" @click="onAcceptUpdate" block>
                    {{updating ? 'Atualizando' : 'Recarregar'}}
                </BsButton>
            </template>
        </BsModal>
    </template>
</template>
<script setup>
import LegacyApp from "@/LegacyApp.vue";
import OpSessionManager from "@/components/OpSessionManager.vue";
import {useUserInfo} from "@/composables/useUserInfo.js";
import {DateAdapter} from "@/modern/core";
import {usePwaInstall} from "@/modern/composables/usePwaInstall";
import {useIcon} from "@bussola-social/ui";
import {useImagesLoader} from "@/modern/composables";
import {computed, ref} from "vue";
import {usePwaUpdate} from "@/modern/composables/usePwaUpdate";

const {isLegacyTheme, userInfoLoaded} = useUserInfo()
const {loadImage} = useImagesLoader()

const dateAdapter = DateAdapter.instance()
const updating = ref(false)

const {
    isInstallModalOpen,
    acceptInstall,
    declineInstall
} = usePwaInstall(dateAdapter)
const {
    applyUpdate,
    isUpdateAvailable
} = usePwaUpdate()

const onAcceptUpdate = () => {
    updating.value = true
    applyUpdate()
}

const showInstallModal = computed(
    () => isInstallModalOpen.value && !isUpdateAvailable.value
)
</script>

<style lang="scss">
.system-modal {
    .v-overlay__content .v-card {
        padding: 16px 24px !important;
    }

    .v-overlay__content .v-card-text {
        padding: 16px 0 !important;
    }

    .v-overlay__content .v-card-actions {
        flex-direction: column !important;
        align-items: stretch !important;
        gap: 8px !important;
    }
}
</style>
